const typeMenuItem = {
    title: 'title',
    itemMenu: 'itemMenu'
}

export { typeMenuItem };